import { render, staticRenderFns } from "./UbicacionesForm.vue?vue&type=template&id=afc384d2&"
import script from "./UbicacionesForm.vue?vue&type=script&lang=js&"
export * from "./UbicacionesForm.vue?vue&type=script&lang=js&"
import style0 from "./UbicacionesForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports